import 'bootstrap/dist/css/bootstrap.min.css';
import "dirham-symbol/dist/index.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast, { Toaster } from 'react-hot-toast';
import { FilterProvider } from "./context/FilterContext";
import Layout from './Layout';
import Products from './pages/Products/Products';
import Product from "./pages/Product/Product";
import Cart from "./pages/Cart/Cart";
import Checkout from "./pages/Checkout/Checkout";
import Home from "./pages/Home/Home";

import ProtectedRoute from "./components/route/ProtectedRoute";
import Login from "./components/admin/Login/Login";
import AdminLayout from "./components/Layout/AdminLayout";
import Dashboard from "./components/admin/Pages/Dashboard/Dashboard";
import Order from './components/admin/Pages/Order/Order';
import ProductList from './components/admin/Pages/ProductList/ProductList';
import Brands from './components/admin/Pages/BrandList/BrandList';
import CategoryList from './components/admin/Pages/CategoryList/CategoryList';
import SliderList from './components/admin/Pages/SliderList/SliderList';
import TopCategoryList from './components/admin/Pages/TopCategoryList/TopCategoryList';
import ProductHighlights from './components/admin/Pages/ProductHighlights/ProductHighlights';
import ProductForm from './components/admin/Form/ProductForm/ProductForm';
import BrandForm from './components/admin/Form/BrandForm/BrandForm';
import CategoryForm from './components/admin/Form/CategoryForm/CategoryForm';
import SubCategoryForm from './components/admin/Form/SubCategoryForm/SubCategoryForm';
import SliderForm from './components/admin/Form//SliderForm/SliderForm';
import TopCategoryForm from './components/admin/Form/TopCategoryForm/TopCategoryForm';
import TrendingProductForm from './components/admin/Form/ProductHighlightsForm/ProductHighlightsForm';
import BlogList from './components/admin/Form/BlogForm/BlogForm';
import BlogForm from './components/admin/Form/BlogForm/BlogForm';
import AboutForm from './components/admin/Form/AboutForm/AboutForm';
import HomeForm from './components/admin/Form/HomeForm/HomeForm';
import OrderSuccess from './pages/OrderSuccess/OrderSuccess';
import OrderError from './pages/OrderError/OrderError';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import MetaList from './components/admin/Pages/MetaList/MetaList';
import './App.css';

import { fetchMenu } from "./actions/menuActions";
import { getActiveBrands } from './actions/brandActions';
import { getActiveCategories } from "./actions/categoryActions";
import { loadUser } from "./actions/userActions";
function App() {

  const dispatch = useDispatch();
  const { menu, loading: menuLoading, error } = useSelector((state) => state.menuState);
  const { categories = [], mainCategories, loading: categoriesLoading, error: categoriesError } = useSelector(state => state.categoriesState);
  const { brands = [], loading: brandLoading, error: brandsError } = useSelector(state => state.brandsState);

  useEffect(() => {
    dispatch(fetchMenu());
    dispatch(getActiveCategories());
    dispatch(getActiveBrands());
  }, [dispatch]);

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  return (
    <Router>
      <ScrollToTop />
      <Toaster
        containerStyle={{
          top: "20%",
          left: "50%",
          transform: "translateX(-50%)",
          maxWidth: "90%",
          width: "auto",
          position: "fixed",
          zIndex: 9999,
        }}
      />

      <FilterProvider>
        <Routes>
          <Route
            path="/*"
            element={
              <Layout menu={menu} categories={categories} brands={brands}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/:category" element={<Products />} />
                  <Route path="/:category/:subCategory" element={<Products />} />
                  <Route path="/:category/:subCategory/:product" element={<Product />} />
                  <Route path="brand/:brand" element={<Products />} />
                  <Route path="brand/:brand/:category" element={<Products />} />
                  <Route path="brand/:brand/:category/:subCategory" element={<Products />} />
                  <Route path="brand/:brand/:category/:subCategory/:product" element={<Product />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-success" element={<OrderSuccess />} />
                  <Route path="/order-error" element={<OrderError />} />
                </Routes>
              </Layout>
            }
          />

          <Route path="/login" element={<Login />} />
          <Route path="/admin/*" element={
            // <ProtectedRoute isAdmin={true}>
            <AdminLayout />
            // </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="orders" element={<Order />} />
            <Route path="products" element={<ProductList />} />
            <Route path="product/add" element={<ProductForm />} />
            <Route path="product/:id" element={<ProductForm />} />
            <Route path="brands" element={<Brands />} />
            <Route path="brand/add" element={<BrandForm />} />
            <Route path="brand/:id" element={<BrandForm />} />
            <Route path="categories" element={<CategoryList />} />
            <Route path="category/add" element={<CategoryForm />} />
            <Route path="category/:id" element={<CategoryForm />} />
            <Route path="subcategory/add" element={<SubCategoryForm />} />
            <Route path="subcategory/:id" element={<SubCategoryForm />} />
            <Route path="slider" element={<SliderList />} />
            <Route path="slider/add" element={<SliderForm />} />
            <Route path="slider/:id" element={<SliderForm />} />
            <Route path="topcat" element={<TopCategoryList />} />
            <Route path="topcat/add" element={<TopCategoryForm />} />
            <Route path="topcat/:id" element={<TopCategoryForm />} />
            <Route path="highlights" element={<ProductHighlights />} />
            <Route path="highlights/add" element={<TrendingProductForm />} />
            <Route path="highlights/:id" element={<TrendingProductForm />} />
            <Route path="blogs" element={<BlogList />} />
            <Route path="blog/add" element={<BlogForm />} />
            <Route path="blog/:id" element={<BlogForm />} />
            <Route path="meta" element={<MetaList />} />
            <Route path="meta/add" element={<HomeForm />} />
            <Route path="meta/:page" element={<HomeForm />} />
            <Route path="page/:page" element={<AboutForm />} />
          </Route>
        </Routes>
      </FilterProvider>
    </Router>
  );
}

export default App;
